
export const login = {
    title: '登录',
    email: '邮箱',
    password: '密码',
    submit: '登录',
    signInWithGoogle: '使用 Google 登录',
    continueWithEmail: '使用邮箱继续',
    enterYourEmail: '输入您的邮箱',
    sendVerificationCode: '发送验证码',
    sending: '发送中...',
    verificationCode: '验证码',
    resend: '重新发送',
    resendIn: '重新发送于',
    signIn: '登录',
    signingIn: '登录中...',
    byContining: '继续即表示您同意我们的',
    termsOfService: '服务条款',
    and: '和',
    privacyPolicy: '隐私政策',
    signInToAccount: '登录您的帐户',
    freeTrialAvailable: '登录后可免费试用',
    loginProcessingFailed: '登录处理失败，请重试',
    googleLoginFailed: 'Google登录失败，请重试',
    resendCodeFailed: '重发验证码失败',
    pleaseEnterEmail: '请输入您的邮箱',
    sendCodeFailed: '发送验证码失败',
    enterEmailError: '请输入您的邮箱',
    enterCodeError: '请输入验证码',
    loginFailed: '登录失败，请检查验证码',
    referralInvitation: '{referrerName} 邀请您注册，注册成功后您将获得 {bonus} 积分奖励！',
    accountExistsLoginSuccess: '登录成功！',
    accountExistsNoReferralPoints: '账户已存在，登录成功！',
    loginSuccessful: '登录成功！',
    loginFailedGeneric: '登录失败',
    registrationSuccessful: '注册成功！',
    registrationFailedGeneric: '注册失败',
    loggedOutSuccessfully: '退出登录成功',
    googleLoginSuccessful: 'Google登录成功！',
    googleLoginFailedGeneric: 'Google登录失败',
    googleLoginFailedNoAuthCode: 'Google登录失败 - 未收到授权码',
    googleLoginFailedError: 'Google登录失败',
    googleLoginFailedAccessDenied: '用户取消了Google登录授权'
  };
